import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/SpinalROM"
import { invokeSetAddSpinalROMAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
//import '../../css/assessment/HeartAndBloodForm.css';

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class SpinalROMForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            userFormData: {}
        }

       this.setUserFormData = this.setUserFormData.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getSpinalROMAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var vertebral_flexion                  = results.data[0].vertebral_flexion;
                var vertebral_extension                = results.data[0].vertebral_extension;
                var transverse_rotation_left_cervical  = results.data[0].transverse_rotation_left_cervical
                var transverse_rotation_right_cervical = results.data[0].transverse_rotation_right_cervical
                var transverse_rotation_left_thoracic  = results.data[0].transverse_rotation_left_thoracic
                var transverse_rotation_right_thoracic = results.data[0].transverse_rotation_right_thoracic;
                var lateral_flexion_left               = results.data[0].lateral_flexion_left;
                var lateral_flexion_right              = results.data[0].lateral_flexion_right;

                this.setState({
                    userFormData: {
                        vertebral_flexion:                  vertebral_flexion,
                        vertebral_extension:                vertebral_extension,
                        transverse_rotation_left_cervical:  transverse_rotation_left_cervical,
                        transverse_rotation_right_cervical: transverse_rotation_right_cervical,
                        transverse_rotation_left_thoracic:  transverse_rotation_left_thoracic,
                        transverse_rotation_right_thoracic: transverse_rotation_right_thoracic,
                        lateral_flexion_left:               lateral_flexion_left,
                        lateral_flexion_right:              lateral_flexion_right
                    }
                });
            }
        } else {
            this.setUserFormData("","","","","","","","");
        }
    }

    setUserFormData(vertebral_flexion, vertebral_extension, transverse_rotation_left_cervical, transverse_rotation_right_cervical, transverse_rotation_left_thoracic, transverse_rotation_right_thoracic, lateral_flexion_left, lateral_flexion_right) {
        this.setState({
            userFormData: {
                vertebral_flexion:                  vertebral_flexion,
                vertebral_extension:                vertebral_extension,
                transverse_rotation_left_cervical:  transverse_rotation_left_cervical,
                transverse_rotation_right_cervical: transverse_rotation_right_cervical,
                transverse_rotation_left_thoracic:  transverse_rotation_left_thoracic,
                transverse_rotation_right_thoracic: transverse_rotation_right_thoracic,
                lateral_flexion_left:               lateral_flexion_left,
                lateral_flexion_right:              lateral_flexion_right
            }
        });
    }

    isObject(obj) {
        return obj != null && obj.constructor.name === "Object"
    }

    onSubmit = async (formData) => {

        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 10; // spinal rom is #4 in dropdown


        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var obj = this.getObjectData(formData);

        var vertebral_flexion                   = obj.vertebral_flexion;
        var vertebral_extension                 = obj.vertebral_extension;
        var transverse_rotation_left_cervical   = obj.transverse_rotation_left_cervical;
        var transverse_rotation_right_cervical  = obj.transverse_rotation_right_cervical;
        var transverse_rotation_left_thoracic   = obj.transverse_rotation_left_thoracic;
        var transverse_rotation_right_thoracic  = obj.transverse_rotation_right_thoracic;
        var lateral_flexion_left                = obj.lateral_flexion_left;
        var lateral_flexion_right               = obj.lateral_flexion_right;

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddSpinalROMAssessment(action, assessment_id, client_id, vertebral_flexion, vertebral_extension, transverse_rotation_left_cervical, transverse_rotation_right_cervical, transverse_rotation_left_thoracic, transverse_rotation_right_thoracic, lateral_flexion_left, lateral_flexion_right)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    getObjectData = (formData) => {
        var vertebral_flexion;
        var vertebral_extension;
        var transverse_rotation_left_cervical;
        var transverse_rotation_right_cervical;
        var transverse_rotation_left_thoracic;
        var transverse_rotation_right_thoracic;
        var lateral_flexion_left;
        var lateral_flexion_right;

        for(var key in formData) {
            var formData2 = formData[key];
            for(var key2 in formData2) {
                var data = formData2[key2];

                if(key2 === "vertebral_flexion" && this.isObject(data) == false) {
                    vertebral_flexion = data;
                } else if(key2 === "vertebral_extension" && this.isObject(data) == false) {
                    vertebral_extension = data;
                } else if(key2 === "transverse_rotation_left_cervical" && this.isObject(data) == false) {
                    transverse_rotation_left_cervical = data;
                } else if(key2 === "transverse_rotation_right_cervical" && this.isObject(data) == false) {
                    transverse_rotation_right_cervical = data;
                } else if(key2 === "transverse_rotation_left_thoracic" && this.isObject(data) == false) {
                    transverse_rotation_left_thoracic = data;
                } else if(key2 === "transverse_rotation_right_thoracic" && this.isObject(data) == false) {
                    transverse_rotation_right_thoracic = data;
                } else if(key2 === "lateral_flexion_left" && this.isObject(data) == false) {
                    lateral_flexion_left = data;
                } else if(key2 === "lateral_flexion_right" && this.isObject(data) == false) {
                    lateral_flexion_right = data;
                }
            }
        }

        var obj = {};
        obj.vertebral_flexion                   = vertebral_flexion;
        obj.vertebral_extension                 = vertebral_extension;
        obj.transverse_rotation_left_cervical   = transverse_rotation_left_cervical;
        obj.transverse_rotation_right_cervical  = transverse_rotation_right_cervical;
        obj.transverse_rotation_left_thoracic   = transverse_rotation_left_thoracic;
        obj.transverse_rotation_right_thoracic  = transverse_rotation_right_thoracic;
        obj.lateral_flexion_left                = lateral_flexion_left;
        obj.lateral_flexion_right               = lateral_flexion_right;

        return obj;
    }

    onChange = (formData) => {
        var obj = this.getObjectData(formData);

        var vertebral_flexion                   = obj.vertebral_flexion;
        var vertebral_extension                 = obj.vertebral_extension;
        var transverse_rotation_left_cervical   = obj.transverse_rotation_left_cervical;
        var transverse_rotation_right_cervical  = obj.transverse_rotation_right_cervical;
        var transverse_rotation_left_thoracic   = obj.transverse_rotation_left_thoracic;
        var transverse_rotation_right_thoracic  = obj.transverse_rotation_right_thoracic;
        var lateral_flexion_left                = obj.lateral_flexion_left;
        var lateral_flexion_right               = obj.lateral_flexion_right;

        this.setUserFormData(vertebral_flexion, vertebral_extension, transverse_rotation_left_cervical, transverse_rotation_right_cervical, transverse_rotation_left_thoracic, transverse_rotation_right_thoracic, lateral_flexion_left, lateral_flexion_right);
    }

    render() {

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <Form style      = {{textAlign:"left", fontSize: "20px !important"}}
                      className  = "assessmentHeartAndBloodForm"
                      schema     = {schema}
                      uiSchema   = {uiSchema}
                      formData   = {this.state.userFormData}
                      onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                      onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                      noValidate = {true}
                >
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
             </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/SpinalROMForm.js